// TODO: llevar esto a DS

// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { Input, Label } from "@artprov/design-system";
import { cn } from "@artprov/design-system";

export const InputComprobante = ({
  placeholderPuntoVenta = 'Pto de venta',
  placeholderNumero = 'Nro de recibo',
  infoPuntoVenta = '',
  infoNumero = '',
  label = 'Datos del comprobante',
  isOptional = false,
  isRequired = false,
  hintsPuntoVenta = [],
  hintsNumero = [],
  statusPuntoVenta = 'default',
  statusNumero = 'default',
  className = '',
  classNameContainer = '',
  classNameContainerInput = 'mb-[4px]',
  disabled = false,
  puntoVenta = '',
  numeroFactura = '',
  // eslint-disable-next-line no-unused-vars
  onChangePuntoVenta = (event) => { },
  onChangeNumero = (event) => { },
  onBlurPuntoVenta = (event) => { },
  onBlurNumero = (event) => { },
  // eslint-disable-next-line no-unused-vars
  rightFunction = null,
  clear = false,
  ...props
}) => {
  const [internalPuntoVenta, setInternalPuntoVenta] = useState(puntoVenta)
  const [internalNumero, setInternalNumero] = useState(numeroFactura)

  const completeWithZeros = (value, cant) => {
    return value.toString().padStart(cant, '0');
  };

  const handleBlurPuntoVenta = () => {
    let newValue = '00001';
    if (internalPuntoVenta != '')
      newValue = completeWithZeros(formatInteger(internalPuntoVenta), 5);
    setInternalPuntoVenta(newValue);
    onBlurPuntoVenta(newValue);

  };

  const handleBlurNumero = () => {
    const newValue = completeWithZeros(formatInteger(internalNumero), 8);
    setInternalNumero(newValue);
    onBlurNumero(newValue);
  };

  const formatInteger = num => {
    const digits = num.replace(/\D/g, '');
    return digits;
  }

  const handleChangePuntoVenta = rawValue => {
    const formattedValue = formatInteger(rawValue);
    handleBlurPuntoVenta;
    setInternalPuntoVenta(formattedValue);
    onChangePuntoVenta(internalPuntoVenta);
  }

  const handleChangeNumero = rawValue => {
    const formattedValue = formatInteger(rawValue);
    handleBlurNumero;
    setInternalNumero(formattedValue);
    onChangeNumero(internalNumero);
  }

  useEffect(() => {
    setInternalNumero("")
    setInternalPuntoVenta("")
  }, [clear])

  useEffect(() => {
    setInternalPuntoVenta(puntoVenta)
  }, [puntoVenta])

  useEffect(() => {
    setInternalNumero(numeroFactura)    
  }, [numeroFactura])

  return (
    <div className="w-[257px]">
      <Label
        label={label}
        className="mt-2 mb-2"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 w-[257px]">
        <div className={cn("mr-1")}>
          <Input
            value={internalPuntoVenta}
            name="puntoVenta"
            id="puntoVenta"
            type="text"
            onChange={handleChangePuntoVenta}
            onBlur={handleBlurPuntoVenta}
            placeholder={placeholderPuntoVenta}
            label=""
            isOptional={isOptional}
            isRequired={isRequired}
            hints={hintsPuntoVenta}
            status={statusPuntoVenta}
            info={infoPuntoVenta}
            disabled={disabled}
            maxCharacters={5}
            rightIcon={false}
            {...props}
          />
        </div>
        <Input
          value={internalNumero}
          name="numeroComprobante"
          id="numeroComprobante"
          type="text"
          onChange={handleChangeNumero}
          onBlur={handleBlurNumero}
          placeholder={placeholderNumero}
          label=""
          isOptional={isOptional}
          isRequired={isRequired}
          hints={hintsNumero}
          status={statusNumero}
          info={infoNumero}
          disabled={disabled}
          maxCharacters={8}
          rightIcon={false}
          autoComplete="off"
          {...props}
        />
      </div>
    </div>
  )
}